<template>
  <div class="multiPickFormItem">
    <span class="label" :style="labelStyle">{{ label }}:</span>
    <div class="multiPickContent">
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="checked" @change="handleCheckedOptionsChange">
        <el-divider content-position="left">加盟</el-divider>
        <el-row>
          <el-col :span="3" v-for="item in [...list.filter(item => item.includes('(加盟)') || item === '系统管理员')]" :key="item">
            <el-checkbox :label="item" :key="item">{{item}}</el-checkbox>
          </el-col>
        </el-row>
        <el-divider content-position="left">直营</el-divider>
        <el-row>
          <el-col :span="3" v-for="item2 in list.filter(item => item.includes('(直营)'))" :key="item2">
            <el-checkbox :label="item2" :key="item2">{{item2}}</el-checkbox>
          </el-col>
        </el-row>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
  export default {
    name: "multiPicker",
    props: {
      label: '',
      value: Array,
      options: [],
      labelWidth: ''
    },
    data(){
      return {
        checkAll: false,
        list: this.options,
        isIndeterminate: false,
        checked: this.value
      }
    },
    mounted(){
      let checkedCount = this.value.length;
        this.checkAll = checkedCount === this.list.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length;
    },
    methods: {
      handleCheckAllChange(val) {
        this.checked = val ? this.list : [];
        this.isIndeterminate = false;
        this.$emit('input', this.checked)
      },
      handleCheckedOptionsChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.list.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length;
        this.$emit('input', this.checked)
      }
    },
    watch: {
      options: function(val, oldVal) {
        this.list = val;
      },
      value: function(val, oldVal) {
        this.checked = val
      }
    },
    computed: {
      labelStyle() {
        const w = this.labelWidth || '100';
        return {
          width: w + 'px'
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  .multiPickFormItem
    display: flex
    margin-bottom: 20px
    .label
      text-align: right
      vertical-align: middle
      float: left
      font-size: 14px
      color: #606266
      line-height: 36px
      padding: 0 12px 0 0
      -webkit-box-sizing: border-box
      box-sizing: border-box
      flex-shrink: 0

    .multiPickContent
      margin-top: 4px
      width: 100%
      line-height: 26px
</style>



// WEBPACK FOOTER //
// src/openSurvey/components/multiPicker.vue